import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import type { DashboardData } from '../../../services/dashboard.service';
import { invoicesByStatusEntries } from '../dashboard-utils';

@Component({
  selector: 'app-dash-invoice-status',
  templateUrl: './dash-invoice-status.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ChartModule],
  styles: [':host { display: block; height: 100%; }']
})
export class DashInvoiceStatusWidgetComponent {
  data = input<DashboardData | null>(null);

  readonly legend = computed(() => {
    const entries = invoicesByStatusEntries(this.data());
    const total = entries.reduce((s, e) => s + e.value, 0);
    const colors = ['#10b981', '#3b82f6', '#f59e0b', '#6366f1', '#ec4899'];
    return entries.map((e, i) => ({
      key: e.key,
      value: e.value,
      percentage: total > 0 ? Math.round((e.value / total) * 100) : 0,
      color: colors[i % colors.length]
    }));
  });

  readonly chartData = computed(() => {
    const entries = invoicesByStatusEntries(this.data());
    if (entries.length === 0) {
      return { labels: [] as string[], datasets: [{ data: [], backgroundColor: [] as string[] }] };
    }
    const colors = ['#10b981', '#3b82f6', '#f59e0b', '#6366f1', '#ec4899'];
    return {
      labels: entries.map((e) => e.key),
      datasets: [
        {
          data: entries.map((e) => e.value),
          backgroundColor: entries.map((_, i) => colors[i % colors.length]),
          hoverBackgroundColor: entries.map((_, i) => colors[i % colors.length])
        }
      ]
    };
  });

  readonly chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    cutout: '60%'
  };
}
